import { render, staticRenderFns } from "./ArtistTrackerNew.vue?vue&type=template&id=5b921286&scoped=true&"
import script from "./ArtistTrackerNew.vue?vue&type=script&lang=js&"
export * from "./ArtistTrackerNew.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=5b921286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b921286",
  null
  
)

export default component.exports